import Cat from '@assets/general/cat404/cat.svg';
import DevRevBubble from '@assets/general/devRev/bubble_l.svg';
import logoForLight from '@assets/logos/Descope_CMYK_ForLightBackground.svg';
import Apple from '@assets/logos/Social/apple.svg';
import Discord from '@assets/logos/Social/discord_w.svg';
import Facebook from '@assets/logos/Social/fb.svg';
import Github from '@assets/logos/Social/github.svg';
import Gitlab from '@assets/logos/Social/gitlab_w.svg';
import Google from '@assets/logos/Social/google.svg';
import AppleIcon from '@assets/logos/Social/icons/icon-apple.svg';
import DiscordIcon from '@assets/logos/Social/icons/icon-discord.svg';
import FacebookIcon from '@assets/logos/Social/icons/icon-fb.svg';
import FingerprintIcon from '@assets/logos/Social/icons/icon-fingerprint.svg';
import GithubIcon from '@assets/logos/Social/icons/icon-github.svg';
import GitlabIcon from '@assets/logos/Social/icons/icon-gitlab.svg';
import GoogleIcon from '@assets/logos/Social/icons/icon-google.svg';
import SSOIcon from '@assets/logos/Social/icons/icon-key.svg';
import LinkedinIcon from '@assets/logos/Social/icons/icon-linkedin.svg';
import MicrosoftIcon from '@assets/logos/Social/icons/icon-ms.svg';
import PasskeyIcon from '@assets/logos/Social/icons/icon-passkey.svg';
import Linkedin from '@assets/logos/Social/linkedin.svg';
import MS from '@assets/logos/Social/microsoft.svg';
import SendGridIconLight from '@assets/logos/connectors/send-grid-light.svg';
import SmtpIconLight from '@assets/logos/connectors/smtp-light.svg';
import TwilioIconLight from '@assets/logos/connectors/twilio-logo-light.svg';
import logoSymbolForLight from '@assets/logos/descope.svg';
import { grey } from '@mui/material/colors';
import { alpha } from '@mui/system';
import { ITheme } from 'types/theme';
import { createBaseTheme, descopeGradient } from './BaseTheme';
import TYPOGRAPHY from './Typography';

const LIGHT_THEME = createBaseTheme({
	palette: {
		mode: 'light',
		primary: {
			main: '#0082B5',
			light: '#80C0DA',
			dark: '#006891'
		},
		secondary: {
			main: '#7D14EB',
			light: '#BE89F5',
			dark: '#6410BC'
		},
		error: {
			main: '#ED404A',
			dark: '#BE333B',
			light: '#ED404A'
		},
		warning: {
			main: '#FF8726',
			dark: '#CC6C1E',
			light: '#FF8726'
		},
		info: {
			main: '#0288D1',
			dark: '#01579B',
			light: '#0288D1'
		},
		success: {
			main: '#4CAF50',
			dark: '#3D8C40',
			light: '#4CAF50'
		},
		border: {
			main: '#E0E0E0'
		},
		action: {
			disabled: 'rgba(0, 0, 0, 0.3)'
		},
		brand: {
			descopeGradient,
			first: '#0082b5',
			second: '#00ffff',
			third: '#6ff12d'
		},
		card: {
			main: '#F7F8F9',
			light: '#E1F5FE'
		},
		wizard: {
			card: {
				main: '#FFFFFF',
				light: '#E1F5FE',
				secondary: '#EDE7F6',
				disabled: '#F5F5F5'
			}
		},
		layout: {
			background: 'grey.50'
		},
		multiline: {
			// using 'grey.100' does not work
			background: grey[100]
		}
	},
	components: {
		MuiListItemButton: {
			styleOverrides: {
				root: ({ theme }) => ({
					'&.Mui-selected': {
						backgroundColor: alpha(theme.palette.primary.light, 0.3)
					}
				})
			}
		},
		MuiIconButton: {
			styleOverrides: {
				root: ({ theme }) => ({
					color: theme.palette.grey[400]
				})
			}
		}
	},
	...TYPOGRAPHY
});

const getLightTheme = (): ITheme => ({
	...LIGHT_THEME,
	assets: {
		socials: {
			Apple: () => Apple,
			Google: () => Google,
			Github: () => Github,
			Facebook: () => Facebook,
			Microsoft: () => MS,
			Discord: () => Discord,
			Linkedin: () => Linkedin,
			Gitlab: () => Gitlab,
			icons: {
				AppleIcon: () => AppleIcon,
				GithubIcon: () => GithubIcon,
				FacebookIcon: () => FacebookIcon,
				FingerprintIcon: () => FingerprintIcon,
				PasskeyIcon: () => PasskeyIcon,
				GoogleIcon: () => GoogleIcon,
				SSOIcon: () => SSOIcon,
				MicrosoftIcon: () => MicrosoftIcon,
				LinkedinIcon: () => LinkedinIcon,
				GitlabIcon: () => GitlabIcon,
				DiscordIcon: () => DiscordIcon
			}
		},
		connectors: {
			SmtpIcon: () => SmtpIconLight,
			SendGridIcon: () => SendGridIconLight,
			TwilioIcon: () => TwilioIconLight
		},
		descope: {
			DescopeLogo: () => logoForLight,
			DescopeLogoSymbol: () => logoSymbolForLight
		},
		general: {
			Cat: () => Cat,
			DevRevBubble: () => DevRevBubble
		}
	}
});

export default getLightTheme;
